import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { absoluteUrl } from "../../_helper";
import Swal from "sweetalert2";
import { emailRegex } from "../../constants/globals";
import RowLoader from "../../Components/UI/RowLoader";
import { postLoginData } from "../../Redux/Auth/AuthCrud";
import { deactivateAccount } from "../../apis";

const DeactivateAccount = () => {
  const [loginPasswordVisible, setLoginPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = { email: "", password: "" };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "Invalid email")
      .required("Required"),
    password: Yup.string().required("Required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      const loginResponse = await postLoginData(values);
      const token = loginResponse?.data?.data?.token;
      if (loginResponse?.data?.data?.success) {
        setIsLoading(false);
        const confirm = await Swal.fire({
          title: "Are you sure?",
          text: "Do you really want to deactivate your account?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, deactivate it!",
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: async () => {
            try {
              const deactivationResponse = await deactivateAccount(token);

              if (!deactivationResponse?.status === true) {
                throw new Error("Deactivation failed");
              }
              return true;
            } catch (error) {
              Swal.showValidationMessage(
                "Error: Unable to deactivate account."
              );
            }
          },
        });

        if (confirm.isConfirmed) {
          Swal.fire(
            "Deactivated!",
            "Your account has been deactivated.",
            "success"
          );
          resetForm();
        }
      } else {
        Swal.fire("Login Failed", "Invalid email or password.", "error");
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);

      Swal.fire(
        "Error",
        error?.response?.data?.message[0] ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <img
        src={absoluteUrl("imgs/loginLogo.png")}
        className="login-logo !-tw-mt-10 tw-mx-auto"
        alt=""
      />
      {/* <h4
        className="tw-text-white tw-text-center !tw-m-0 tw-font-bold tw-text-lg !-tw-mt-10"
        style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        UNITERS ACADEMY
      </h4> */}
      <h3 className="tw-text-lg text-center mb-3 !-tw-mt-10">
        Deactivate Your Account
      </h3>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-group mb-3">
              <div className="input-icon">
                <span className="fa fa-envelope login-icon-field !tw-text-secondary"></span>
                <Field
                  name="email"
                  type="email"
                  placeholder="Email"
                  className={`form-control tw-border-b-2 pr-3 tw-border-secondary !tw-border-x-0 !tw-border-t-0 !tw-rounded-none ${
                    errors.email && touched.email
                      ? "tw-border !tw-border-red-500"
                      : ""
                  }`}
                />
              </div>
              <ErrorMessage
                name="email"
                component="div"
                className="invalid-feedback"
              />
            </div>

            <div className="form-group mb-3 position-relative">
              <div className="input-icon">
                <span className="fa fa-lock login-icon-field !tw-text-secondary tw-text-xl"></span>
                <span
                  className="material-icons c-white login-icon-field login-icon-field-show-password tw-text-xl !tw-text-secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    setLoginPasswordVisible((prev) => !prev);
                  }}
                >
                  visibility{loginPasswordVisible ? "_off" : ""}
                </span>
                <Field
                  name="password"
                  placeholder="Password"
                  type={loginPasswordVisible ? "text" : "password"}
                  className={`form-control tw-border-b-2 pr-3 tw-border-secondary !tw-border-x-0 !tw-border-t-0 !tw-rounded-none  ${
                    errors.password && touched.password
                      ? "tw-border !tw-border-red-500"
                      : ""
                  }`}
                />
              </div>
              <ErrorMessage
                name="password"
                component="div"
                className="invalid-feedback"
              />
            </div>

            <button
              type="submit"
              className="btn !tw-bg-primary tw-w-full tw-text-white mt-3 hover:!tw-text-[#eee] tw-h-10"
            >
              {isLoading ? <RowLoader /> : "Submit"}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DeactivateAccount;
